import * as React from 'react';

import { AppRoutes } from 'constants/routes';

import ArrowLeft from 'assets/icons/arrows/arrow-left-16.svg';

import CircleButton from 'basics/buttons/CircleButton';
import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import {
    Bar,
    SkeletonRow,
    SkeletonStack,
} from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import AssetInfoLoading from 'components/AssetInfoContent/AssetInfoLoading';

import { PageContainer } from 'styles/commonPageStyles';
import { COLORS } from 'styles/style-constants';

import { MobileSidebar } from './AssetRegistryVotingLoading.styled';
import {
    AssetInfoSection,
    Content,
    Header,
    Main,
    MainColumn,
    SectionCard,
    SectionTitle,
    SidebarColumn,
} from './AssetRegistryVotingPage.layout';

const VotingSummary = () => (
    <SkeletonStack $gap="2.4rem">
        <Bar $width="70%" $height="2.8rem" />
        <Bar $width="100%" $height="0.8rem" />
        {[0, 1, 2].map(i => (
            <SkeletonRow key={i}>
                <Bar $width="40%" $height="2rem" />
                <Bar $width="30%" />
            </SkeletonRow>
        ))}
        <Bar $width="100%" $height="4.8rem" />
    </SkeletonStack>
);

const AssetRegistryVotingLoading = () => (
    <PageContainer $color={COLORS.gray50}>
        <ContentPlaceholder label="Loading asset proposal">
            <Main>
                <MainColumn>
                    <Header>
                        <CircleButton
                            to={AppRoutes.section.assetRegistry.link.index}
                            label="Asset Registry List"
                        >
                            <ArrowLeft />
                        </CircleButton>
                        <AssetInfoSection>
                            <AssetInfoLoading />
                        </AssetInfoSection>
                    </Header>
                    <Content>
                        <MobileSidebar>
                            <VotingSummary />
                        </MobileSidebar>
                        <SectionCard>
                            <SectionTitle>Proposal</SectionTitle>
                            <SkeletonStack>
                                <Bar $width="100%" />
                                <Bar $width="90%" />
                                <Bar $width="65%" />
                                {[0, 1, 2, 3].map(i => (
                                    <SkeletonStack key={i}>
                                        <Bar $width="9rem" />
                                        <Bar $width="65%" $height="2.4rem" />
                                    </SkeletonStack>
                                ))}
                            </SkeletonStack>
                        </SectionCard>
                    </Content>
                </MainColumn>
                <SidebarColumn>
                    <SectionCard>
                        <VotingSummary />
                    </SectionCard>
                </SidebarColumn>
            </Main>
        </ContentPlaceholder>
    </PageContainer>
);

export default AssetRegistryVotingLoading;
